import {DatePipe} from '@angular/common';
import {Injectable} from '@angular/core';
import {DateUtil} from '../util/DateUtil';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private datePipe: DatePipe) {
  }

  dateFormat(date): string {
    return this.datePipe.transform(new Date(date), DateUtil.dateFormat);
  }

  dateTimeFormat(): string {
    return this.datePipe.transform(new Date(), DateUtil.dateTimeFormat);
  }
}
